import HeroSection from "./components/HeroSection";
import FlowSection from "./components/FlowSection";
import TimelineSection from "./components/TimelineSection";
import PricingSection from "./components/PricingSection";
import CostCalculatorSection from "./components/CostCalculatorSection";
import FaqSection from "./components/FaqSection";
import FinalCtaSection from "./components/FinalCtaSection";
import SEOMeta from "@/components/feature/SEOMeta";

const siteUrl = (typeof import.meta !== "undefined" && import.meta.env?.VITE_SITE_URL) || "https://chronosspace.com";

const jsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      "name": "服務流程與收費｜速築美宅家 Chronos Space",
      "description": "速築美宅家 Chronos Space 提供自地自建流程、土地評估、建築設計、預算試算、報建法規、開工監造、室內軟裝與透明收費說明。",
      "url": `${siteUrl}/process`
    },
    {
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "工期多久？會不會延宕？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "一般會依基地、規模、工法與審查進度而不同。我們會以關鍵路徑排程與節點管理協助控管，並在說明會中建立初步時程概念。"
          }
        },
        {
          "@type": "Question",
          "name": "預算會不會越做越高？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "我們會透過工項拆解、規格表與變更確認機制降低預算失控。所有變更都應先估價與簽認後再執行。"
          }
        },
        {
          "@type": "Question",
          "name": "沒有完整圖面也能開始嗎？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "可以。可先從說明會、需求盤點、基地條件與生活情境開始，逐步進入設計深化。"
          }
        },
        {
          "@type": "Question",
          "name": "可以只做設計，不含工程嗎？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "可以。設計與工程執行可分開規劃，也可依業主既有團隊條件配合。"
          }
        },
        {
          "@type": "Question",
          "name": "丈量或提案費可以折抵設計費嗎？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "可依實際方案規劃，若進入正式設計階段，可將部分或全部費用折抵正式設計費，實際以合約內容為準。"
          }
        },
        {
          "@type": "Question",
          "name": "為何坪數相同，費用卻不同？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "居住需求、基地條件、結構系統、材料等級、工法細節與室內規劃深度都會影響費用。"
          }
        }
      ]
    }
  ]
};

export default function Process() {
  return (
    <main>
      <SEOMeta
        title="服務流程與收費"
        description="速築美宅家 Chronos Space 提供自地自建流程、土地評估、建築設計、預算試算、報建法規、開工監造、室內軟裝與透明收費說明。"
        keywords="自地自建流程,建築設計費用,自地自建收費,預製工法流程,危老重建流程"
        canonicalPath="/process"
        jsonLd={jsonLd}
      />
      <HeroSection />
      <FlowSection />
      <TimelineSection />
      <PricingSection />
      <CostCalculatorSection />
      <FaqSection />
      <FinalCtaSection />
    </main>
  );
}